const app_promo = {
  "app_promo.block_title": "<span>MyACUVUE®</span> <span><em>App會員優惠</em></span> <span>盡在彈指之間</span>",
  "app_promo.li_01": "專享獨家優惠",
  "app_promo.li_02": "消費賺取積分",
  "app_promo.li_03": "兌換積分於下次消費時使用",
  "app_promo.cta_title": "立即登記成為MyACUVUE® App會員",
  "app_promo.cta_btn": "<a>了解更多</a>",
  "app_promo.cta_link": "https://www.acuvue.com.hk/get-contacts/MyACUVUE",
}

export default app_promo;
